<template>
  <v-menu
    ref="menu"
    v-model="isMenuOpen"
    content-class="zoox-component zoox-menu-chip-date mt-2"
    max-width="290px"
    offset-overflow
    :disabled="disabled"
    :offset-y="bottom || top"
    :offset-x="left || right"
    :bottom="bottom"
    :left="left"
    :right="right"
    :top="top"
    :return-value.sync="internalRange"
    :close-on-content-click="
      activeMenu === 'list' && internalValue !== 'custom'
    "
  >
    <template #activator="{on, attrs}">
      <z-chip
        class="zoox-component zoox-chip zoox-filterable-chip-date"
        icon="$date_range_rounded"
        :color="color"
        :dark="dark"
        :selected="selected"
        :disabled="disabled"
        :small="small"
        :x-small="xSmall"
        :text="defineChipText"
        v-bind="attrs"
        v-on="on"
        @click="isMenuOpen = !isMenuOpen"
      ></z-chip>
    </template>

    <v-list v-if="activeMenu === 'list'" dense>
      <v-list-item-group
        color="primary"
        :value="internalValue"
        @change="onChangeSelectedInterval"
      >
        <v-list-item
          v-for="(item, i) in items"
          ref="listItem"
          :key="i"
          :value="item.value"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <v-date-picker
      v-if="activeMenu === 'date-picker'"
      ref="date-picker"
      v-click-outside="onClickOutsidePicker"
      no-title
      show-adjacent-months
      scrollabe
      color="primary"
      range
      next-icon="$keyboard_arrow_right_rounded"
      prev-icon="$keyboard_arrow_left_rounded"
      :max="maxDate"
      :value="internalRange"
      @input="onChangeDatePickerValue"
    >
      <v-spacer></v-spacer>

      <z-btn
        :text="$t('return')"
        :color="cancelBtnColor"
        @click="onCancel"
      ></z-btn>

      <z-btn
        primary
        :text="$t('save')"
        :color="confirmBtnColor"
        :disabled="internalRange.length !== 2"
        @click="onConfirm"
      ></z-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import {compareAsc, format, parseISO} from 'date-fns'
import {isEqual} from 'lodash'

export default {
  props: {
    /**
     * Define a formatação das datas
     */
    languageFormat: {
      type: String,
      default: 'pt-BR',
    },
    /**
     * Define o range de datas selecinados
     */
    value: {
      type: Array,
      default: () => [],
    },
    confirmBtnColor: {
      type: String,
      default: 'primary',
    },
    cancelBtnColor: {
      type: String,
      default: 'primary',
    },
    top: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: true,
    },
    left: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    xSmall: {
      type: Boolean,
      default: false,
    },

    noEmptyValue: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isMenuOpen: false,
      activeMenu: 'list',
      internalValue: null,

      internalRange: [],
    }
  },

  i18n: {
    messages: {
      en: {
        return: 'Return',
        save: 'Save',
        select_interval: 'Select interval',
      },
      es: {
        return: 'Volver',
        save: 'Ahorrar',
        select_interval: 'Seleccionar intervalo',
      },
      pt: {
        return: 'Voltar',
        save: 'Salvar',
        select_interval: 'Selecionar intervalo',
      },
      fr: {
        return: 'Retour',
        save: 'Enregistrer',
        select_interval: 'Sélectionner un intervalle',
      },
      tr: {
        return: 'Geri dön',
        save: 'Kaydet',
        select_interval: 'Aralık seç',
      },
    },
  },

  computed: {
    defineChipText() {
      if (!this.value || !this.value.length) return this.$t('select_interval')

      const sortedDates = this.value
        .map((date) => parseISO(date))
        .sort(compareAsc)

      const [start, end] = sortedDates.map((date) => {
        switch (this.languageFormat) {
          case 'pt-BR':
          case 'es-ES':
            return format(date, 'dd/MM/yyyy')
          case 'en-US':
            return format(date, 'MM/dd/yyyy')
          default:
            return format(date, 'dd/MM/yyyy')
        }
      })

      return `${start} - ${end}`
    },

    maxDate() {
      return new Date().toISOString().substring(0, 10)
    },

    items() {
      const days = [7, 15, 30, 60, 90]
      const items = []
      const today = new Date().toISOString().substring(0, 10)

      days.forEach((_, i) => {
        const todayMinusInterval = this.subtractDays(days[i])
          .toISOString()
          .substring(0, 10)

        items.push({
          text: `Últimos ${days[i]} dias`,
          value: [todayMinusInterval, today],
        })
      })

      items.push({text: 'Período customizado', value: 'custom'})
      return items
    },

    isCustomInterval() {
      return !this.items.some((item) => isEqual(item.value, this.value))
    },
  },

  mounted() {
    if (this.value && this.value.length > 0 && this.isCustomInterval) {
      this.internalValue = 'custom'
      this.internalRange = [...this.value]
      return
    }

    if (this.value && this.value.length > 0) {
      this.internalValue = [...this.value]
    }
  },

  methods: {
    onChangeDatePickerValue(value) {
      this.internalRange = value
    },

    onChangeSelectedInterval(value) {
      //se já existe um intervalo customizado, abre o date-picker
      if ((this.internalValue === 'custom' && !value) || value === 'custom') {
        this.internalValue = 'custom'
        this.activeMenu = 'date-picker'
        return
      }

      //ao clicar em uma opção já selecionada, desselecione a opção
      if ((!value || isEqual(value, this.value)) && !this.noEmptyValue) {
        this.internalValue = null
        this.$refs.menu.save([])

        this.$emit('input', [])
        return
      } else if (!value && this.noEmptyValue) {
        this.internalValue = [...this.value]

        return
      }

      //clicando em um opção pré-definida, selecione-a e limpa os ranges / ou abra o date-picker
      if (Array.isArray(value)) {
        this.activeMenu = 'list'

        this.internalValue = value
        this.$refs.menu.save([])
        this.$emit('input', value)
      } else {
        this.activeMenu = 'date-picker'
      }
    },

    onCancel() {
      this.activeMenu = 'list'

      setTimeout(() => {
        if (this.value && this.value.length && this.isCustomInterval) {
          this.internalValue = 'custom'
        } else if (this.value && this.value.length && !this.isCustomInterval) {
          this.internalValue = [...this.value]
        } else {
          this.internalValue = null
        }

        this.internalRange =
          this.value && this.value.length && this.isCustomInterval
            ? [...this.value]
            : []
      }, 0)
    },

    onConfirm() {
      this.activeMenu = 'list'

      const sortedDates = this.internalRange
        .map((date) => parseISO(date))
        .sort(compareAsc)

      this.$refs.menu.save(this.internalRange)
      this.$emit(
        'input',
        sortedDates.map((d) => format(d, 'yyyy-MM-dd'))
      )
    },

    onClickOutsidePicker() {
      this.activeMenu = 'list'

      if (this.value && this.value.length && this.isCustomInterval) {
        this.internalValue = 'custom'
      } else if (this.value && this.value.length && !this.isCustomInterval) {
        this.internalValue = [...this.value]
      } else {
        this.internalValue = null
      }
    },

    subtractDays(numOfDays, date = new Date()) {
      const dateCopy = new Date(date.getTime())

      dateCopy.setDate(dateCopy.getDate() - numOfDays)

      return dateCopy
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-menu-chip-date {
  border-radius: var(--component-card-radius);
  box-shadow: var(--zoox-card-shadow);
}
</style>
